
export const getLink = (name, prefix) => (prefix ? prefix+'_' : '') + name.toLowerCase().split(' ').join('-')